var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"close botao-fechar-pequeno",attrs:{"aria-label":"Close"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("x")]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }